<template>
	<div
		class="c-Card"
		:class="cardClassObj">
		<!-- @slot generic slot for card -->
		<slot />
	</div>
</template>
<script>
export default {
	props: {
		/**
     * The Card type
     * @values is-white, is-dark
     */
		type: {
			type: String,
			required: false,
			default: () => 'is-white',
			validator(type) {
				return [
					'is-white',
					'is-dark'
				].includes(type);
			},
		},
	},
	computed: {
		cardClassObj() {
			return {
				'is-white': this.type === 'is-white',
				'is-dark': this.type === 'is-dark',
			};
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Card {
  border-radius: calc(#{$border-radius} * 2);
  padding:
    calc(#{$base-padding} * 1.5)
    calc(#{$base-padding} * 2)
    calc(#{$base-padding} * 1.5)
    calc(#{$base-padding} * 2);

  &.is-white {
    background-color: $un-white;
    border: 1px solid $un-n200;
    box-shadow: 2px 2px 5px 3px $un-gray1-dark;
  }

  &.is-dark {
    background-color: $un-gray-bg;
    border: 1px solid $un-gray-bd;
  }
}
</style>
